import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const modifyRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/modifyremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const addProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/addprocessremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchAddProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/duplicateterminalnumanalysisresult/batchaddprocessremark/' + params.ids + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

